module.exports = __webpack_public_path__ + "assets/img/uesrIcon5.6ff12a63.png";